export default {
    setActiveModal({ commit }, payload) {
        payload && payload.modal ? commit('setActiveModal', payload.modal) : commit('resetActiveModal');
        payload && payload.origin ? commit('setModalOrigin', payload.origin) : commit('resetModalOrigin');
        payload && payload.mode ? commit('setModalMode', payload.mode) : commit('resetModalMode');
    },
};
